'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;



/*****************
 ** WEBPACK FOOTER
 ** ./~/math-intrinsics/floor.js
 ** module id = 942
 ** module chunks = 9
 **/